import { Injectable } from '@angular/core';

const guidPattern = /[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}/gi;

export function replaceGuids(value: string): string {
  return value.replaceAll(guidPattern, '[hidden-ID]');
}

export const AnalyticsEvent = {
  PAGE_VIEW: 'page_view',
  CHAT_TOGGLE: 'chat_toggle',
  FIRST_CHAT_MESSAGE_SENT: 'first_chat_message_sent',
} as const;

@Injectable({ providedIn: 'root' })
export class AnalyticsTrackingService {
  private get gtag() {
    return globalThis.gtag;
  }

  pageView(url: string, title?: string) {
    this.event(AnalyticsEvent.PAGE_VIEW, {
      page_path: url,
      page_title: title ?? document.title,
    });
  }

  event(name: string, params: Record<string, unknown> = {}) {
    if (!this.gtag) return;

    if (!params['page_location']) {
      params['page_location'] = globalThis.location.href;
    }

    // Sanitize all string parameters to replace GUIDs with a placeholder
    // This ensures that no personally identifiable information or sensitive data is sent to analytics platforms
    const sanitizedParams = Object.fromEntries(
      Object.entries(params).map(([key, value]) => [
        key,
        typeof value === 'string' ? replaceGuids(value) : value,
      ]),
    );

    this.gtag('event', name, sanitizedParams);
  }
}
